module.exports = __webpack_public_path__ + "img/part_6_4.cd811491.png";